import { LegalDocumentScreen } from '@/modules/legal/components/LegalDocumentScreen';
import { useLocalSearchParams } from 'expo-router';
import React from 'react';

export default function PrivacyPolicyScreen() {
    const params = useLocalSearchParams<{ onAccept?: string }>();
    
    const handleAccept = () => {
        // Handle accept action if needed
        // This can be used to update state or perform actions
    };

    return (
        <LegalDocumentScreen
            documentName="privacy-policy"
            {...(params.onAccept ? { onAccept: handleAccept } : {})}
        />
    );
}

